<template>
  <transition name="el-zoom-in-top">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增奖品</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-show="show">
        <!-- 填写基础信息 -->
        <el-form
          ref="awardform"
          :model="awardform"
          label-width="120px"
          style="width:50%"
          :rules="rules"
        >
          <el-form-item label="商品名称" prop="awardStuffName">
            <el-input v-model="awardform.awardStuffName" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="上传图片" >
              <el-upload
                ref="upload"
                :action="uploadurl"
                :data="uploaddata"
                list-type="picture-card"
                :on-success="qinchulist"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :auto-upload="false"
                :file-list="fileList"
                :limit="1"
                :on-change="onchange"
                name="uploadFile"
              >
              <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
                <i class="el-icon-plus"></i>
                            </el-tooltip>
              </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="图片展开" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="总卷面值" prop="awardStuffTotal">
            <el-input v-model.number="awardform.awardStuffTotal" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="卷面值" prop="awardStuffValue">
            <el-input v-model.number="awardform.awardStuffValue" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="是否置顶" prop="awardStuffIstop">
            <el-switch v-model="awardform.awardStuffIstop"></el-switch>
          </el-form-item>
          <el-form-item label="详细信息" prop="remark">
            <el-input type="textarea" v-model="awardform.remark"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('awardform')">重置</el-button>
          <el-button style="margin-top: 12px;" @click="submitadd('awardform')" type="primary">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  findlistbytype
} from "@/api/market/pond";
import { awardstuffVoucheradd } from "@/api/market/marketing";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: "",
          avatar: "",
          roles: ""
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      awardStuffPoollist:[],
      show: true,
      active: 1,
      awardform: {
        awardStuffValue:0,
        awardStuffName: null,
        awardStuffTotal: 0,
        awardStuffImageurl:null,
        awardStuffIstop: false,
        remark: null,
      },
      // 上传图片
      uploaddata: { folder: "Hirisw" },
      uploadurl:
        process.env.VUE_APP_BASE_API +
        "/mtscitech/back/fileuploader/fileupload",
        ifFile:false,
        fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        awardStuffName: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        awardStuffTotal: [
          { required: true, message: "请输入奖品总卷面值", trigger: "blur" },
          { type: 'number', message: '必须为数字值'}
        ],
        awardStuffValue: [
          { required: true, message: "请输入奖品金额", trigger: "blur" },
          { type: 'number', message: '必须为数字值'}
        ],
      }
    };
  },
  mounted() {},
  methods: {
        //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片
          if (this.ifFile) {
            this.uploadurl = process.env.VUE_APP_BASE_API + "/mtscitech/back/fileuploader/fileupload";
          this.$refs.upload.submit();
          }else{
            awardstuffVoucheradd(this.awardform).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.add.addshow=false;
              this.resetForm('awardform')
              this.search();
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
          }
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
    //文件上传 
    submitUpload() {
    },
    // upload
    handleRemove(file, fileList) {
      this.ifFile = false;
      console.log(this.update.ifFile);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange(file){
     this.ifFile = !this.ifFile
    },
    qinchulist(response, file, fileList){ //  图片上传成功后获取图片地址再提交
      //  this.$refs.upload.clearFiles();
       this.awardform.awardStuffImageurl=response.data;
       awardstuffVoucheradd(this.awardform).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.resetForm('awardform')
              this.search();
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
